const getEnvironment = () => {
    const { hostname } = window.location;
    let env = 'prod';
    if (hostname.includes('wwwstage')) {
        env = 'stage';
    } else if (hostname.includes('wwwdev')) {
        env = 'dev';
    } else if (hostname === 'localhost') {
        env = 'local';
    }
    return env;
};

const environment = getEnvironment();
export default environment;
